import { css } from 'aphrodite';
import * as React from 'react';
import { WarningIconSmall, WarningIconType } from '../../../web/components/svgs/icons/WarningIcon';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
}

// Compliance banner: card data must never be captured in a Zoom recording/transcript (PCI).
export const PaymentRecordingWarning: React.FC<IProps> = ({ className }) => {
	return (
		<div className={`payment-recording-warning ${css(styleSheet.container)} ${className || ''}`} role='alert'>
			<WarningIconSmall className={css(styleSheet.icon)} type={WarningIconType.Red} />
			<div className={css(styleSheet.content)}>
				<p className={css(styleSheet.title)}>Stop your Zoom recording and transcript before collecting payment</p>
				<p className={css(styleSheet.message)}>
					Payment card details must never be captured in a call recording or transcript. Turn off any active Zoom
					recording and live transcript before entering or reading the customer&apos;s payment information.
				</p>
			</div>
		</div>
	);
};
